<div [ngClass]="{ 'separate-item': header() === true }">
  <mat-list-item>
    @if (header()) {
      <mat-icon
        class="igo-chevron"
        matListItemIcon
        igoCollapse
        [target]="ogcFilters"
        [collapsed]="filtersCollapsed"
        (click)="toggleFiltersCollapsed()"
        >expand_less
      </mat-icon>
    }
    @if (header()) {
      <span
        matListItemTitle
        [ngStyle]="{ cursor: filtersCollapsed ? 'default' : 'pointer' }"
        [matTooltip]="layer().title"
        matTooltipShowDelay="500"
        (click)="toggleLegendOnClick()"
      >
        {{ layer().title }}
      </span>
    }
    <div matListItemMeta>
      @if (isAdvancedOgcFilters() && filtersAreEditable) {
        <button
          [disabled]="addFilterDisabled()"
          mat-icon-button
          tooltip-position="below"
          matTooltipShowDelay="500"
          [matTooltip]="'igo.geo.filter.addFilter' | translate"
          [color]="color"
          (click)="addFilterToSequence()"
        >
          <mat-icon>add</mat-icon>
        </button>
      }
      @if (header()) {
        <button
          mat-icon-button
          [color]="layer().visible ? 'primary' : 'default'"
          collapsibleButton
          tooltip-position="below"
          matTooltipShowDelay="500"
          [matTooltip]="
            layer().visible
              ? ('igo.geo.layer.hideLayer' | translate)
              : ('igo.geo.layer.showLayer' | translate)
          "
          (click)="toggleLayerVisibility()"
        >
          <mat-icon
            [ngClass]="{ disabled: (inResolutionRange$ | async) === false }"
            >{{ layer().visible ? 'visibility' : 'visibility_off' }}
          </mat-icon>
        </button>
      }
    </div>
  </mat-list-item>

  <div #ogcFilters>
    @if (header()) {
      <div #legend class="igo-layer-legend-container">
        @if (showLegend$ | async) {
          <igo-layer-legend [layer]="layer()" />
        }
      </div>
    }
    <igo-ogc-filterable-form
      [datasource]="datasource"
      [map]="map()"
      [refreshFilters]="refreshFunc"
    />

    @if (hasSelector && filtersAreEditable) {
      <section class="advancedOgcFilters">
        <mat-divider />
        <mat-checkbox
          (change)="changeOgcFilterType($event)"
          [(ngModel)]="datasource.options.ogcFilters.advancedOgcFilters"
        >
          {{ 'igo.geo.filter.advancedOgcFilters' | translate }}
        </mat-checkbox>
      </section>
    }
  </div>
</div>
